<template>
  <div class="block pagequer">
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[12, 24, 48, 96]"
      :page-size="12"
      layout="total, sizes, prev, pager, next, jumper"
      :total="listNum"
    >
    </el-pagination>
  </div>
</template>
  <script>
export default {
  name: "Pagination",
  props: ["listNum", "getList"],
  methods: {
    handleSizeChange(val) {
      this.$data.pageSize = val;
      this.getList(this.$data.currentPage, this.$data.pageSize);
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.$data.currentPage = val;
      console.log(this.$parent.$parent.$parent);
      this.getList(this.$data.currentPage, this.$data.pageSize);
      console.log(`当前页: ${val}`);
    },
  },
  data() {
    return {
      currentPage: 1,
      pageSize: 12,
    };
  },
};
</script>
  <style scoped>
.pagequer {
  width: 100%;
  margin: 40px auto 40px auto;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Pagination.vue